import styled from "styled-components";
import media from "../../styles/media";

/** Горизонтальные поля и максимальная ширина контента страницы. */
export const Container = styled.div`
  width: 100%;
  max-width: ${({ theme }) => theme.layout.maxWidth};
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.layout.gutter};

  ${media.md} {
    padding: 0 16px;
  }
`;

export default Container;
